import React from 'react';
import { v4 } from 'uuid';
import _ from 'lodash';

import { Checkbox, IconButton, TableCell } from '@mui/material';
import { DragIndicator, Edit } from '@mui/icons-material';

const TableRow = (props) => {
  const { row, keys, selected } = props;
  const { setSelected, dragHandle, onRowClick } = props;
  const { showCheckbox, showAction } = props;

  let totalCell = 0;
  const tableCheckboxCellProps = {
    padding: 'checkbox',
  };
  const checked = row.id ? selected.indexOf(row.id) > -1
    : (row.ids ? _.difference(row.ids || [], selected).length === 0 : false);

  const checkboxProps = {
    size: 'small',
    color: 'error',
    checked,
    onChange() {
      if (row.id) {
        const newSelected = Object.assign([], selected);
        const i = newSelected.indexOf(row.id);
        if (i > -1) {
          newSelected.splice(i, 1);
        } else {
          newSelected.push(row.id);
        }
        setSelected(newSelected);
      } else if (row.ids) {
        if (checked) {
          setSelected(_.difference(selected, row.ids));
        } else {
          setSelected(_.uniq(_.concat(selected, row.ids)));
        }
      }
    },
    inputProps: {
      // 'aria-labelledby': labelId,
    },
    sx: ({ palette }) => ({
      color: palette.error.main,
      p: 0,
    }),
  };

  return (
    <>
      {!!showCheckbox && (
        <TableCell {...tableCheckboxCellProps}>
          {row.id || row.id === 0 || (row.ids || []).length > 0 ? (<Checkbox {...checkboxProps} />) : ''}
        </TableCell>
      )}

      {keys.map((key) => {
        let cell = row[key] || '';
        let tableCellProps = {
          key: `cell-${row.id || (row.ids || []).join(':') || v4()}-${key}`,
          align: 'left',
        };
        if (Array.isArray(row[key])) {
          cell = row[key][0]; // eslint-disable-line prefer-destructuring
          tableCellProps = { ...tableCellProps, ...row[key][1] };
        }
        totalCell += (tableCellProps.colSpan || 1);

        if (totalCell > keys.length) {
          return null; // fix table
        }

        return (<TableCell {...tableCellProps}>{cell}</TableCell>);
      })}

      {!!showAction && (
        <TableCell>
          {typeof onRowClick === 'function' ? (
            <IconButton size="small" onClick={(event) => onRowClick(row, event)}>
              <Edit color="primary" fontSize="small" />
            </IconButton>
          ) : (
            <Edit color="primary" fontSize="small" />
          )}
        </TableCell>
      )}

      {dragHandle ? (
        <TableCell {...dragHandle}><DragIndicator /></TableCell>
      ) : null}
    </>
  );
};

export default TableRow;
